// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607290525/js/" + chunkId + "." + {"44":"9777c69a","225":"c68c03b3","481":"e4a3793a","486":"989f9f03","770":"a446a281"}[chunkId] + ".0.17290677259758225.chunk.js";
};